// FormField.tsx
import React from "react";
import { FormikTouched } from "formik";

interface FormFieldProps<T> {
  name?: string;
  label: string;
  required?: boolean;
  error?: string;
  touched?: boolean | FormikTouched<T>[] | undefined;
  children: React.ReactNode;
  className?: string;
}

export const FormField = <T,>({
  label,
  required = false,
  error,
  touched,
  children,
  className = "",
}: FormFieldProps<T>) => {
  // Helper to safely check if touched
  const isTouched = typeof touched === 'boolean' ? touched : false;
  
  return (
    <div className={`fields ${className}`}>
      <label className={isTouched && error ? "error-label" : ""}>
        {label} {required && <code>*</code>}
      </label>
      {children}
      {isTouched && error && <div className="error-label">{error}</div>}
    </div>
  );
};